import { FC, useState } from "react";
import NoVendor from "src/assets/icons/NoVendor";
import DialogModal from "src/components/Dialog";
import Icon from "src/components/Icon";
import Info from "src/components/Info";
import AddPlanner from "../modals/AddPlanner";
import styles from "./styles.module.scss";

interface Props {
  page: number;
  pageSize: number;
}

const EmptyState: FC<Props> = ({ page, pageSize }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles["EmptyState"]}>
      <Info>
        <Icon iconName="bulb" />

        <p className={styles["EmptyState--title"]}>
          Add details of vendors involved in making your event a success
        </p>
      </Info>

      <div className={styles["EmptyState--main"]}>
        <NoVendor />

        <p>You've not added your event vendors</p>
        <DialogModal
          open={open}
          onOpenChange={setOpen}
          trigger={
            <div
              onClick={() => setOpen(true)}
              className={styles["EmptyState--main__trigger"]}
            >
              <span>Add Vendor</span>
            </div>
          }
        >
          <AddPlanner page={page} pageSize={pageSize} setOpen={setOpen} />
        </DialogModal>
      </div>
    </div>
  );
};

export default EmptyState;
